import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5c33dd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "Contador", -1))
const _hoisted_2 = { class: "display" }

import useCounter from '../composables/useCounter'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { num, disabled, increase, decrease, reset } = useCounter()

return (_ctx: any,_cache: any) => {
  const _component_app_btn = _resolveComponent("app-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    "max-width": "360",
    class: "d-flex flex-column mx-auto align-center pa-8 elevation-20"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(num)), 1),
      _createElementVNode("div", null, [
        _createVNode(_component_app_btn, {
          disabled: _unref(disabled),
          icon: "mdi-minus",
          onClick: _unref(decrease)
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_app_btn, {
          onClick: _unref(increase),
          icon: "mdi-plus"
        }, null, 8, ["onClick"])
      ]),
      _createVNode(_component_app_btn, {
        block: "",
        disabled: _unref(disabled),
        onClick: _unref(reset),
        icon: "mdi-restore"
      }, null, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }))
}
}

})